var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorFrecciaDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.41,181.59l299.94,244.31c18.22,14.84,40.31,22.25,62.48,22.25s44.26-7.42,62.48-22.25l302.25-246.2c42.37-34.54,48.71-96.77,14.18-139.13-34.45-42.37-96.77-48.71-139.13-14.26l-239.77,195.35L161.37,28.19C119-6.26,56.69.09,22.23,42.45c-34.54,42.37-28.11,104.6,14.18,139.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.41,529.34l299.94,244.31c18.22,14.84,40.31,22.25,62.48,22.25s44.26-7.42,62.48-22.25l302.25-246.2c42.37-34.54,48.71-96.77,14.18-139.13-34.54-42.37-96.77-48.71-139.13-14.18l-239.77,195.26-237.46-193.37c-42.37-34.54-104.68-28.11-139.13,14.18-34.54,42.37-28.11,104.68,14.18,139.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorFrecciaDown);
export default __webpack_public_path__ + "static/media/monitor-freccia-down.de3eba706483520ba71965e5f488e43a.svg";
export { ForwardRef as ReactComponent };